import React, { Children, useEffect, useState, useRef } from 'react';
import styled from 'styled-components'
import { Button, notification } from 'antd';

const Drawer = ({children, visible, onClose}) => {

  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);

  const childRef = useRef(null);
  const ChildContext = React.createContext();

  const onOk = () => {
    childRef.current.onOk()
  }

  return (
    <DrawerContainer visible={visible}>
      <Header>
        <CloseButton onClick={onClose}>x</CloseButton>
        <ButtonContainer>
          <Button style={{ marginRight: "10px" }} onClick={onClose}>
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={onOk}
            disabled={disabled}
            loading={loading}
          >
            Submit
          </Button>
        </ButtonContainer>
      </Header>
      {React.cloneElement(children, { ref: childRef, setDisabled, setLoading })}
    </DrawerContainer>
  );
}

const DrawerContainer = styled.div`
  flex: 0 0 500px;
  width: 500px;
  position: relative;
  margin-right: ${p => p.visible ? '0' : '-500px'};
  transition: margin 0.3s ease;
  background-color: #fff;
  height: 100vh;
  margin-top: -50px;
  border-left: 1px solid #dee0e3;
`
const Header = styled.div`
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #dee0e3;
`
const ButtonContainer = styled.div`
  float: right;
  padding-right: 10px;
  box-sizing: border-box;
`
const CloseButton = styled.span`
    float: left;
    height: 48px;
    width: 48px;
    line-height: 45px;
    font-size: 20px;
    color: #666;
    z-index: 5;
    background-color: #fff;
    text-align: center;
    box-sizing: border-box;
    cursor: pointer;
    pointer-events: auto;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    &:hover {
      color: #000;
    }
`

export default Drawer;